module.exports = __webpack_public_path__ + "img/img_kb_type2_slide03.cc6c4c69.png";